/*
  APO render swapper (fform, v14 31 Oct; v17 3 Nov: gallery first until the customer picks)

  Watches the APO fields (mw_opts[...]) and shows the matching render as the first
  gallery image (main gallery, thumbnails and the zoom modal).

  - Renders come from custom.apo_options (embedded by apo-options-data.liquid). Liquid
    only lists the first 50, so for any other combination the render is loaded by its
    file name (/cdn/shop/files/<handle>-<selected values>.jpg, webp / png also tried) or,
    failing that, by its metaobject handle through templates/search.apo-render.liquid.
  - No flicker: the next render is downloaded first and swapped in directly from the
    previous render. The original product image is only put back when nothing matches.
  - Extra images on a render entry are inserted as extra slides after the first one.
  - Matching only uses whole parts of a render title ("Viola" never shows a "Viola Calacatta"
    render) and ignores the order of the picks.
  - Removes the duplicate "Selected ..." lines the options app injects.
  - v14: when the first gallery item is a video (or 3D model), the render goes into a new
    image slide put in front of it (copied from the first photo slide), so picking an option
    always shows the render instead of staying on the video. Reset removes it again.
  - v14: a render is shown at most 120 ms after it has downloaded (img.decode() can hang,
    which left the previous render on screen).
  - v15 (3 Nov, Claude for Tyrone):
    * Every render of the product is used, not only the first 50: the full list is loaded once
      from templates/product.ff-renders.liquid (/products/<handle>?view=ff-renders).
    * Shopify options count too. Since 1 Nov Frame (and on some products Size) is a Shopify
      option, so picking a frame never changed the render. Now a Shopify option is part of the
      match when its value is part of a render title, compared word by word, so "Powdercoat Blue"
      finds "Blue Frame", "Black Powdercoat Frame" or "Black Powdercoat Base".
    * After a pick the render stays in front: the theme jumps to a variant's own photo when the
      variant changes, which hid the render (most often on pages that start with a video).
    * Copied slides lose the original slide's inline position, and the slider is refreshed so
      the new first slide is the one on screen.
    * Once every render is known the closest one is shown at once, so switching is instant
      (before, titles with an extra part, e.g. "Armrest", always went through the slow file name
      lookups). The file name lookup stays as the last resort.
    * A pick also matches a title that splits it with " - " ("Corner Chaise - Right").
  - v16 (3 Nov, Claude for Tyrone), once every render is known:
    * An option only has to be in the render title if its values are in some render title. Balance,
      Arch and the Blob timber entry name the stone but not the timber, so they never matched.
    * Those other picks (e.g. the timber) choose between the entry's own images by file name
      ("...-oak-natural", "...-walnut-natural"); a finish with no image of its own shows the photo.
    * Entries without an image are ignored, and nothing is guessed through search any more, so a
      stone with no render (plain Viola) shows the product photo instead of another stone.
  - v34 (3 Nov night, Claude for Tyrone): rebuilt tables have separate Top and Base options with
    stone classes, while their renders are titled with the old "Top and Base" words ("Natural stone
    top, timber indoor ply base - Volakas - Oak - Natural"). On those pages the old words for the
    chosen top and base (from assets/fform-top-base-split.js) count as one more pick, so a stone base
    or another base never shows a stone-top render. Tables with "Top and Base" are unchanged.
*/
(function () {
  'use strict';

  function txt(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }
  // strips the options app's price suffix in any currency, e.g. "(+$300.00 AUD)" or "(+Gs. 1259658 PYG)"
  function clean(v) { return txt(v).replace(/\s*\(\+[^()]*\d[^()]*\)\s*$/, '').replace(/^-+$/g, ''); }
  function low(v) { return clean(v).toLowerCase(); }
  function slug(v) { return String(v || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  var ALIAS = { ambient: 'ambiant', ambiant: 'ambient', 'vegan-leather': 'vegan-nubuck-leather', 'lustrell-aura': 'aura' };

  function fieldText(f) {
    if (f.tagName === 'SELECT') return f.selectedIndex >= 0 && f.value !== '' ? clean(f.options[f.selectedIndex].text) : '';
    if (f.type === 'radio' || f.type === 'checkbox') {
      var l = f.id ? document.querySelector('label[for="' + CSS.escape(f.id) + '"]') : null;
      return clean(l ? l.textContent : f.value);
    }
    return clean(f.value);
  }

  function groups() {
    var names = {};
    document.querySelectorAll('[name^="mw_opts["]').forEach(function (f) {
      // finish dropdowns hidden for the chosen Top and Base don't count
      if (f.closest('.ff-finish-hidden')) return;
      names[f.name] = true;
    });
    return Object.keys(names).map(function (n) { return Array.prototype.slice.call(document.querySelectorAll('[name="' + CSS.escape(n) + '"]')); });
  }

  // Material and finish options always change the render. Any other option (e.g. Size)
  // only counts when one of its values is a part of a render title.
  var RENDER_LABEL = /top and base|top, base|stone|veneer|2pac|powdercoat|metal finish|timber specialty|upholstery|fabric|colou?rway|leather|boucle|velvet/i;
  function labelOf(f) {
    var o = f.closest('.mw-option');
    var l = o ? o.querySelector('label') : null;
    return l ? txt(l.textContent) : '';
  }
  function optionTexts(fields) {
    var f = fields[0];
    if (f.tagName === 'SELECT') return Array.prototype.filter.call(f.options, function (o) { return o.value !== ''; }).map(function (o) { return clean(o.text); });
    return fields.map(function (x) { return fieldText(x) || clean(x.value); });
  }
  // v16: strict = every render is known, so an option counts only when its values are in a title
  var affCache = {};
  function affectsRender(fields, list, strict) {
    if (!list.length) return true;
    var f = fields[0];
    if (!strict && RENDER_LABEL.test(labelOf(f))) return true;
    var ck = (strict ? 's' : 'l') + list.length + '|' + productTitle + '|' + f.name;
    if (affCache[ck] !== undefined) return affCache[ck];
    var texts = optionTexts(fields);
    return (affCache[ck] = texts.some(function (t) { return t && list.some(function (o) { return has(o, t); }); }));
  }

  // v15: the Shopify option picks (Frame, Size ...) of the main product form, by option name.
  function apoLabels() {
    var names = {};
    document.querySelectorAll('.mw-apo-container .mw-option').forEach(function (o) {
      if (o.closest('quick-add-modal')) return;
      var l = o.querySelector('.mw-label .mw-text') || o.querySelector('label');
      if (l) names[low(txt(l.textContent).replace(/\s*\*\s*$/, ''))] = 1;
    });
    return names;
  }
  var optionNames = null;
  function shopifyPicks(sid) {
    var out = [];
    var root = document.getElementById('ProductInfo-' + sid) || document.getElementById('MainProduct-' + sid) || document;
    var picker = root.querySelector('variant-radios, variant-selects');
    if (!picker || picker.closest('quick-add-modal')) return out;
    picker.querySelectorAll('fieldset[data-option-position]').forEach(function (fs) {
      var c = fs.querySelector('input[type=radio]:checked');
      var i = +fs.getAttribute('data-option-position') - 1;
      if (c) out.push({ name: optionNames && optionNames[i] || '', value: c.value, all: Array.prototype.map.call(fs.querySelectorAll('input[type=radio]'), function (r) { return r.value; }) });
    });
    picker.querySelectorAll('select[name^="options["]').forEach(function (s) {
      var m = /^options\[(.+)\]$/.exec(s.name);
      if (s.value) out.push({ name: m ? m[1] : '', value: s.value, all: Array.prototype.map.call(s.options, function (o) { return o.value; }) });
    });
    return out;
  }

  function selected(list, sid, strict) {
    var out = [], complete = true, extra = [];
    groups().forEach(function (fields) {
      if (!fields.length) return;
      var f = fields[0], v = '';
      if (f.tagName === 'SELECT') v = fieldText(f);
      else if (f.type === 'radio' || f.type === 'checkbox') { var c = fields.filter(function (x) { return x.checked; })[0]; v = c ? fieldText(c) : ''; }
      else v = fieldText(f);
      if (!affectsRender(fields, list, strict)) {
        // v16: a material or finish that is not in any title can still pick between an entry's images
        if (strict && v && RENDER_LABEL.test(labelOf(f))) extra.push({ v: v, texts: optionTexts(fields) });
        return;
      }
      if (v) out.push(v); else complete = false;
    });
    // v15: a Shopify option counts only when its value is part of a render title. An option that
    // Mageworx also shows (same name, e.g. Size or Top and Base) is already counted above.
    if (list.length && sid) {
      var idx = runsOf(list), apo = apoLabels(), seen = {};
      out.forEach(function (v) { seen[norm(v)] = 1; seen[toks(v)] = 1; });
      shopifyPicks(sid).forEach(function (p) {
        if (apo[low(p.name)]) return;
        var k = toks(p.value), run = k && idx[k];
        // v16: other frames have renders but this one doesn't (e.g. Ivory on Aire): show the photo,
        // not another frame's render
        if (!run && strict && !/^(material|fabrics?|upholstery|colou?r|colou?rway|fabric (and|&) colou?rway)$/i.test(txt(p.name)) &&
          (p.all || []).some(function (v) { var t = toks(v); return t && idx[t]; })) { out.push(p.value); return; }
        if (!run || seen[norm(run)] || seen[k]) return;
        seen[norm(run)] = 1; seen[k] = 1;
        out.push(run);
      });
    }
    // v34: rebuilt tables (separate Top and Base) add the old "Top and Base" words as a pick, when
    // the render titles use such words
    var sp = window.ffSplitTB && window.ffSplitTB.phrase ? window.ffSplitTB.phrase() : '';
    if (sp && list.length && list.some(function (o) { return /(^| - )[^-]*( top, | throughout( - |$))/.test(restOf(o)); })) {
      out.push(sp);
      out = out.filter(function (v, i) { return out.indexOf(v) === i; });
    }
    return { values: out, complete: complete, extra: extra };
  }

  // Normalised text for comparing a pick with a render title:
  // "Kona (Stone)" and "Kona Stone" compare equal, case and spacing don't matter.
  function norm(v) { return low(v).replace(/[()]/g, ' ').replace(/&/g, 'and').replace(/\s+/g, ' ').trim(); }

  // v15: word-by-word comparison for Shopify option values ("Powdercoat Blue" = "Blue Frame").
  var GENERIC = { frame: 1, base: 1, legs: 1, leg: 1, powdercoat: 1, satin: 1, finish: 1, colour: 1, color: 1, and: 1 };
  var TSPLIT = { midbronze: ['mid', 'bronze'] };
  function toks(v) {
    var out = [];
    norm(v).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').forEach(function (w) {
      if (!w || GENERIC[w]) return;
      (TSPLIT[w] || [w]).forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
    });
    return out.sort().join(' ');
  }
  // Every run of 1 to 3 " - " parts in the render titles, by its words, e.g. "blue" -> "Blue Frame".
  var partsIndex = null, partsFor = null;
  function runsOf(list) {
    if (partsFor === list && partsIndex) return partsIndex;
    partsIndex = {}; partsFor = list;
    list.forEach(function (o) {
      var p = restOf(o).split(' - ');
      for (var i = 0; i < p.length; i++) for (var n = 1; n <= 3 && i + n <= p.length; n++) {
        var run = p.slice(i, i + n).join(' - '), k = toks(run);
        if (k && !partsIndex[k]) partsIndex[k] = run;
      }
    });
    return partsIndex;
  }

  // Render titles are "<Product title> - <value> - <value> ...". Values can contain " - "
  // themselves (e.g. "Oak - Natural"), so picks are matched as whole " - " bounded runs.
  var productTitle = null;
  function restOf(o) {
    if (o._rest !== undefined && o._pt === productTitle) return o._rest;
    var t = norm(o.title), p = productTitle ? norm(productTitle) + ' - ' : '';
    o._pt = productTitle;
    o._rest = p && t.indexOf(p) === 0 ? t.slice(p.length) : t.split(' - ').slice(1).join(' - ');
    return o._rest;
  }
  function posIn(o, v) { return (' - ' + restOf(o) + ' - ').indexOf(' - ' + norm(v) + ' - '); }
  // v15: some titles split a value with " - " ("Corner Chaise - Right" for "Corner chaise right"), so a
  // pick also counts when a run of 1 to 3 title parts has exactly its words.
  function words(v) {
    var a = norm(v).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
    return a.filter(function (w, i) { return a.indexOf(w) === i; }).sort().join(' ');
  }
  function runKeys(o) {
    if (o._rk && o._rkpt === productTitle) return o._rk;
    var p = restOf(o).split(' - '), rk = {};
    for (var i = 0; i < p.length; i++) for (var n = 1; n <= 3 && i + n <= p.length; n++) rk[words(p.slice(i, i + n).join(' '))] = 1;
    o._rk = rk; o._rkpt = productTitle;
    return rk;
  }
  function has(o, v) { return posIn(o, v) >= 0 || !!runKeys(o)[words(v)]; }
  function hasAll(o, values) { return values.every(function (v) { return has(o, v); }); }
  function isExact(o, values) {
    if (!hasAll(o, values)) return false;
    var len = values.reduce(function (a, v) { return a + norm(v).length; }, 0) + 3 * (values.length - 1);
    if (restOf(o).length === len) return true;
    return words(restOf(o)) === words(values.join(' '));  // same words, split differently
  }

  // Find the listed render for the picks. Only whole values count, so "Viola" never
  // matches "Viola Calacatta" and "Black" never matches "Black Basalt".
  function findListed(list, values, complete) {
    if (!values.length || !list.length) return null;
    var exact = list.filter(function (o) { return isExact(o, values); })[0];
    if (exact) return exact;
    if (complete) return null;  // full pick with no exact render: the caller tries the file name next
    // part way through picking: any render that has every pick so far
    return list.filter(function (o) { return hasAll(o, values); })[0] || null;
  }

  // Older titles may carry an extra part. Used only after the file name lookup fails.
  function findLoose(list, values) {
    return list.filter(function (o) { return hasAll(o, values); })[0] || null;
  }
  // v15: once every render is known, the closest one wins straight away (the one with the fewest
  // extra parts, e.g. "Armrest - Atlas (Parchment) - Polished Chrome Frame"), no file name guessing.
  function findBest(list, values) {
    var best = null;
    list.forEach(function (o) { if (imagesOf(o).length && hasAll(o, values) && (!best || restOf(o).length < restOf(best).length)) best = o; });
    return best;
  }
  // v16: picks that are not in the titles choose between an entry's images by file name.
  // An option whose values are in none of the file names doesn't split the images and is ignored.
  function fileKey(u) { return '-' + String(u).split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-'; }
  function pickImages(o, extra) {
    var imgs = imagesOf(o).slice();
    if (imgs.length < 2 || !extra || !extra.length) return imgs;
    for (var k = 0; k < extra.length; k++) {
      var keys = imgs.map(fileKey);
      var inFile = function (t) { var s = '-' + slug(t) + '-'; return s.length > 2 && keys.some(function (x) { return x.indexOf(s) >= 0; }); };
      if (!extra[k].texts.some(inFile)) continue;
      var s = '-' + slug(extra[k].v) + '-', idx = -1;
      keys.forEach(function (x, i) { if (idx < 0 && x.indexOf(s) >= 0) idx = i; });
      if (idx < 0) return null;   // this finish has no image of its own
      imgs.unshift(imgs.splice(idx, 1)[0]);
    }
    return imgs;
  }
  // v16: no title has every pick, but an entry's image file names carry the missing ones
  // (Arch "Timber indoor ply throughout - No stone" holds ...-oak-natural and ...-walnut-natural)
  function findByFile(list, values) {
    var best = null;
    list.forEach(function (o) {
      var keys = imagesOf(o).map(fileKey), miss = [];
      if (!keys.length) return;
      for (var i = 0; i < values.length; i++) {
        if (has(o, values[i])) continue;
        var s = '-' + slug(values[i]) + '-';
        if (s.length < 4 || !keys.some(function (x) { return x.indexOf(s) >= 0; })) return;
        miss.push(values[i]);
      }
      if (!miss.length) return;
      if (!best || miss.length < best.miss.length || (miss.length === best.miss.length && restOf(o).length < restOf(best.o).length)) best = { o: o, miss: miss };
    });
    return best;
  }

  // Put the picks in the order they appear in the render titles (that's the file name order).
  function titleOrder(list, values) {
    var pos = values.map(function (v, i) {
      var best = 1e6;
      for (var k = 0; k < list.length && best === 1e6; k++) { var j = posIn(list[k], v); if (j >= 0) best = j; }
      return { v: v, p: best, i: i };
    });
    return pos.sort(function (a, b) { return a.p - b.p || a.i - b.i; }).map(function (x) { return x.v; });
  }

  function imagesOf(o) {
    if (!o) return [];
    if (Array.isArray(o.images) && o.images.length) return o.images.filter(Boolean);
    return o.image ? [o.image] : [];
  }

  // Candidate file names for a combination that isn't in the listed 50.
  function fileCandidates(handle, values) {
    var parts = values.map(slug);
    var names = [handle + '-' + parts.join('-')];
    parts.forEach(function (p, i) {
      Object.keys(ALIAS).forEach(function (a) {
        if (p.indexOf(a) === 0) { var c = parts.slice(); c[i] = ALIAS[a] + p.slice(a.length); names.push(handle + '-' + c.join('-')); }
      });
    });
    var urls = [];
    names.forEach(function (n) { ['jpg', 'webp', 'png'].forEach(function (e) { urls.push('/cdn/shop/files/' + n + '.' + e + '?width=2000'); }); });
    return urls;
  }

  // Metaobject handles for a combination: "<handle>-<slugged values>" and the older
  // compact style "<handle>-<range>-<colour>-<valuewithoutspaces>" (e.g. walnutdarkstain).
  function compact(v) { return String(v || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, ''); }
  function handleCandidates(handle, values) {
    var a = handle + '-' + values.map(slug).join('-');
    var b = handle + '-' + values.map(function (v) {
      var m = clean(v).match(/^(.*?)\s*\((.*)\)\s*$/);
      return m ? compact(m[1]) + '-' + compact(m[2]) : compact(v);
    }).join('-');
    return a === b ? [a] : [a, b];
  }
  var looked = {};
  function lookupHandle(h, cb) {
    if (looked[h] !== undefined) return cb(looked[h]);
    fetch('/search?q=' + encodeURIComponent(h) + '&view=apo-render&type=product')
      .then(function (r) { return r.json(); })
      .then(function (o) { looked[h] = o || null; cb(looked[h]); }, function () { looked[h] = null; cb(null); });
  }
  // v15: all renders of a product, from templates/product.ff-renders.liquid (250 per page).
  // Shared with the Request images form through window.ffApoRenders.
  var FULL = {};
  function loadAll(handle) {
    if (FULL[handle]) return FULL[handle];
    FULL[handle] = new Promise(function (resolve) {
      var out = [], seen = {}, n = 0;
      // pages follow the template's own "next" link (Liquid names the page parameter itself)
      function next(url) {
        n++;
        fetch(url)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var rs = j && Array.isArray(j.renders) ? j.renders : [];
            rs.forEach(function (o) { if (o && o.title && !seen[o.handle || o.title]) { seen[o.handle || o.title] = 1; out.push(o); } });
            if (j && j.next && n < 5) next(j.next); else resolve(out);
          }, function () { resolve(out); });
      }
      next('/products/' + encodeURIComponent(handle) + '?view=ff-renders');
    });
    return FULL[handle];
  }
  window.ffApoRenders = window.ffApoRenders || { load: loadAll };

  var loaded = {};
  function preload(url, cb) {
    if (loaded[url] === 1) return cb(true);
    if (loaded[url] === -1) return cb(false);
    var img = new Image();
    img.onload = function () {
      loaded[url] = 1;
      // decode() can stay pending (e.g. while the tab is in the background), so never wait on it for long
      var called = false;
      function go() { if (!called) { called = true; cb(true); } }
      setTimeout(go, 120);
      if (img.decode) img.decode().then(go, go); else go();
    };
    img.onerror = function () { loaded[url] = -1; cb(false); };
    img.src = url;
  }

  // A combination that isn't in the listed 50: try the file names and the metaobject
  // handles (both value orders) all at once, then take the first hit in priority order.
  function resolveRender(handle, values, ordered, cb) {
    var orders = [ordered];
    if (ordered.join('|') !== values.join('|')) orders.push(values);
    var urls = [], hs = [];
    orders.forEach(function (o) {
      fileCandidates(handle, o).forEach(function (u) { if (urls.indexOf(u) < 0) urls.push(u); });
      handleCandidates(handle, o).forEach(function (h) { if (hs.indexOf(h) < 0) hs.push(h); });
    });
    var fileOk = [], found = [], left = urls.length + hs.length;
    function done() {
      if (--left > 0) return;
      for (var i = 0; i < urls.length; i++) if (fileOk[i]) return cb([urls[i]]);
      for (var j = 0; j < hs.length; j++) if (found[j] && found[j].length) return cb(found[j]);
      cb(null);
    }
    urls.forEach(function (u, i) { preload(u, function (ok) { fileOk[i] = ok; done(); }); });
    hs.forEach(function (h, j) { lookupHandle(h, function (o) { found[j] = imagesOf(o); done(); }); });
  }

  function contexts(sid) {
    var out = [];
    var sec = document.getElementById('MainProduct-' + sid);
    if (sec) {
      var ml = sec.querySelector('.product__media-list');
      if (ml) {
        var wrap = ml.querySelector('.swiper-wrapper') || ml;
        var sl = sec.querySelector('.product__media-sublist');
        var tw = sl ? sl.querySelector('.swiper-wrapper') || sl : null;
        out.push({ list: ml, wrap: wrap, first: wrap.querySelector('.product__media-item:not([data-apo-inserted])'), tlist: sl, twrap: tw, tfirst: tw ? tw.querySelector('.product__media-subitem:not([data-apo-inserted])') : null });
      }
    }
    var modal = document.getElementById('ProductModal-' + sid);
    if (modal) {
      var c = modal.querySelector('.product-media-modal__content');
      var msl = modal.querySelector('.product__media-sublist__sidebar-nav .product__media-sublist');
      var mtw = msl ? msl.querySelector('.swiper-wrapper') || msl : null;
      if (c) out.push({ modal: modal, wrap: c, first: c.querySelector('.product-media-modal__item:not([data-apo-inserted])'), tlist: msl, twrap: mtw, tfirst: mtw ? mtw.querySelector('.product__media-subitem:not([data-apo-inserted])') : null });
    }
    return out;
  }

  function setImgs(el, src) {
    if (!el) return;
    el.querySelectorAll('img').forEach(function (img) {
      if (!img.hasAttribute('data-apo-orig-src')) {
        img.setAttribute('data-apo-orig-src', img.getAttribute('src') || '');
        img.setAttribute('data-apo-orig-srcset', img.getAttribute('srcset') || '');
        img.setAttribute('data-apo-orig-sizes', img.getAttribute('sizes') || '');
      }
      // srcset first, so the browser never falls back to the original in between
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.loading = 'eager';
    });
  }
  function restoreImgs(el) {
    if (!el) return;
    el.querySelectorAll('img[data-apo-orig-src]').forEach(function (img) {
      var s = img.getAttribute('data-apo-orig-srcset');
      var z = img.getAttribute('data-apo-orig-sizes');
      if (z) img.setAttribute('sizes', z);
      if (s) img.setAttribute('srcset', s);
      img.setAttribute('src', img.getAttribute('data-apo-orig-src'));
      img.removeAttribute('data-apo-orig-src');
      img.removeAttribute('data-apo-orig-srcset');
      img.removeAttribute('data-apo-orig-sizes');
    });
  }
  function refreshSwipers(ctx) {
    if (ctx.list && ctx.list.swiper) ctx.list.swiper.update();
    if (ctx.tlist && ctx.tlist.swiper) ctx.tlist.swiper.update();
  }
  function removeInserted(ctx) {
    ctx.wrap.querySelectorAll('[data-apo-inserted]').forEach(function (n) { n.remove(); });
    if (ctx.twrap) ctx.twrap.querySelectorAll('[data-apo-inserted]').forEach(function (n) { n.remove(); });
  }

  function isPhoto(el) {
    return !!(el && el.querySelector('img') && !el.querySelector('video, iframe, deferred-media, product-model, model-viewer, .product__media--autoplay-video'));
  }
  function siblingsOf(el) {
    return Array.prototype.filter.call(el.parentNode.children, function (n) {
      return n.tagName === el.tagName && !n.hasAttribute('data-apo-inserted') && n.className.split(' ')[0] === el.className.split(' ')[0];
    });
  }
  function strip(n) {
    n.setAttribute('data-apo-inserted', 'true');
    // v15: the copy must not keep the original slide's position or hidden state
    n.style.transform = ''; n.style.opacity = ''; n.style.transitionDuration = ''; n.removeAttribute('aria-hidden');
    ['data-media-id', 'data-media-modal-id', 'data-media-sub-id'].forEach(function (a) { n.removeAttribute(a); });
    n.querySelectorAll('[data-media-id]').forEach(function (x) { x.removeAttribute('data-media-id'); });
    n.classList.remove('is-active');
    return n;
  }
  // Where the render goes: the first slide when it is a photo, otherwise a copy of the first
  // photo slide placed in front of the video / 3D model.
  function lead(ctx, sid) {
    if (isPhoto(ctx.first)) return { slide: ctx.first, thumb: ctx.tfirst };
    var items = siblingsOf(ctx.first), idx = -1;
    for (var i = 0; i < items.length; i++) { if (isPhoto(items[i])) { idx = i; break; } }
    if (idx < 0) return null;
    var s = strip(items[idx].cloneNode(true));
    s.setAttribute('data-apo-lead', 'true');
    if (ctx.modal) s.id = sid + '-apo-1';
    ctx.first.insertAdjacentElement('beforebegin', s);
    var t = null;
    if (ctx.tfirst) {
      var titems = siblingsOf(ctx.tfirst);
      var src = titems[idx] && titems[idx].querySelector('img') ? titems[idx] : titems.filter(function (x) { return x.querySelector('img'); })[0];
      if (src) {
        t = strip(src.cloneNode(true));
        t.querySelectorAll('.product__media-icon, [class*="play"]').forEach(function (x) { if (!x.querySelector('img')) x.remove(); });
        var a = ctx.modal ? t.querySelector('a[href^="#"]') : null;
        if (a) a.setAttribute('href', '#' + s.id);
        ctx.tfirst.insertAdjacentElement('beforebegin', t);
      }
    }
    return { slide: s, thumb: t };
  }

  // v15: right after a pick, keep the render in front. The theme slides to the variant's own
  // photo when the variant changes (updateMedia), which used to hide the render.
  var pinUntil = 0, pinned = [];
  function pin() { pinUntil = Date.now() + 2500; }
  function pinSwiper(sw) {
    if (!sw || pinned.indexOf(sw) >= 0 || !sw.on) return;
    pinned.push(sw);
    sw.on('slideChange', function () {
      if (Date.now() < pinUntil && currentShown && sw.activeIndex !== 0) {
        var s0 = sw.slides[0];
        if (s0 && (s0.querySelector('img[data-apo-orig-src]') || s0.hasAttribute('data-apo-lead'))) sw.slideTo(0, 0);
      }
    });
  }
  var currentShown = false;

  function show(sid, images) {
    contexts(sid).forEach(function (ctx, ci) {
      removeInserted(ctx);
      if (!ctx.first) return;
      // v15: the theme can move a variant's own photo to the front (mobile list); put back any
      // photo that still shows the previous render, so only the first slide carries it
      ctx.wrap.querySelectorAll('img[data-apo-orig-src]').forEach(function (img) {
        var it = img.closest('.product__media-item, .product-media-modal__item');
        if (it && it !== ctx.first) restoreImgs(it);
      });
      if (ctx.twrap) ctx.twrap.querySelectorAll('img[data-apo-orig-src]').forEach(function (img) {
        var it = img.closest('.product__media-subitem');
        if (it && it !== ctx.tfirst) restoreImgs(it);
      });
      var L = lead(ctx, sid);
      if (!L) return;
      setImgs(L.slide, images[0]);
      setImgs(L.thumb, images[0]);
      var after = L.slide, tafter = L.thumb;
      images.slice(1).forEach(function (src, i) {
        var s = strip(L.slide.cloneNode(true));
        s.removeAttribute('data-apo-lead');
        if (ctx.modal) s.id = sid + '-apo-' + (i + 2);
        setImgs(s, src);
        after.insertAdjacentElement('afterend', s); after = s;
        if (tafter) {
          var t = strip(L.thumb.cloneNode(true));
          setImgs(t, src);
          var a = ctx.modal ? t.querySelector('a[href^="#"]') : null;
          if (a && s.id) a.setAttribute('href', '#' + s.id);
          tafter.insertAdjacentElement('afterend', t); tafter = t;
        }
      });
      refreshSwipers(ctx);
      if (ci === 0 && ctx.list && ctx.list.swiper) {
        var sw = ctx.list.swiper;
        // v15: when a slide was put in front of a video the index stays 0 but the slider still
        // shows the old slide; going to 1 and back to 0 (no animation) puts the render on screen
        if (sw.activeIndex !== 0) sw.slideTo(0, 0);
        else if (L.slide.hasAttribute('data-apo-lead') && sw.slides.length > 1) { sw.slideTo(1, 0, false); sw.slideTo(0, 0, false); }
        pinSwiper(sw);
      }
      if (ci === 0 && ctx.tlist && ctx.tlist.swiper && ctx.tlist.swiper.activeIndex !== 0) ctx.tlist.swiper.slideTo(0, 0);
      if (ci === 0 && ctx.twrap) {
        Array.prototype.forEach.call(ctx.twrap.children, function (n) { n.classList.remove('is-active', 'swiper-slide-thumb-active'); });
        if (L.thumb) L.thumb.classList.add('swiper-slide-thumb-active');
      }
    });
  }
  function reset(sid) {
    contexts(sid).forEach(function (ctx) { removeInserted(ctx); restoreImgs(ctx.first); restoreImgs(ctx.tfirst); refreshSwipers(ctx); });
  }

  function removeAppSelectedLines(sid) {
    var root = document.getElementById('ProductInfo-' + sid);
    if (!root) return;
    root.querySelectorAll('p, div, li, span').forEach(function (n) {
      if (!/^Selected\s+[^:]+:/i.test(txt(n.textContent))) return;
      var r = n.closest('p, li, div') || n;
      if (r) r.remove();
    });
  }

  function init(root) {
    var sid = root.dataset.section;
    var list = [];
    try { var d = root.querySelector('script[data-apo-options]'); if (d) list = JSON.parse(d.textContent) || []; } catch (e) {}
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle = m ? decodeURIComponent(m[1]) : '';
    var shownKey = null, token = 0, current = null, fullLoaded = false;
    // v17: the page opens on the gallery (video, then in situ). Renders only switch in after the
    // customer picks something; the preselected default Frame or Size is not a pick.
    var touched = false;
    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); })
        .then(function (p) {
          productTitle = p && p.title || null;
          optionNames = (p && p.options || []).map(function (o) { return txt(o && o.name || o); });
          partsFor = null; shownKey = null; update();
        }, function () {});
      // v15: every render of the product (the embedded list stops at 50)
      loadAll(handle).then(function (all) {
        if (!all.length) return;
        var have = {};
        list.forEach(function (o) { have[o.handle || o.title] = 1; });
        all.forEach(function (o) { if (!have[o.handle || o.title]) { list.push(o); have[o.handle || o.title] = 1; } });
        fullLoaded = true;
        partsFor = null; shownKey = null; update();
      });
    }

    function update() {
      if (!touched) {
        if (shownKey !== '#untouched') { shownKey = '#untouched'; current = null; currentShown = false; reset(sid); }
        return;
      }
      var sel = selected(list, sid, fullLoaded);
      var key = sel.values.map(low).join('|') + '#' + sel.extra.map(function (e) { return low(e.v); }).join('|');
      if (key === shownKey) return;
      shownKey = key;
      var my = ++token;
      if (!sel.values.length) { current = null; currentShown = false; reset(sid); return; }
      function apply(images) {
        if (my !== token) return;          // a newer pick is on its way, keep the current render
        if (images && images.length) { current = images; currentShown = true; show(sid, images); }
        else if (sel.complete || fullLoaded) { current = null; currentShown = false; reset(sid); }  // no render for the picks: back to the product photo
      }
      // v16: with every render known, the closest entry with an image wins; nothing is guessed
      if (fullLoaded) {
        var best = findBest(list, sel.values), bi = best ? pickImages(best, sel.extra) : null;
        if (!bi || !bi.length) {
          var fb = findByFile(list, sel.values);
          if (fb) bi = pickImages(fb.o, fb.miss.map(function (v) { return { v: v, texts: [v] }; }).concat(sel.extra));
        }
        if (bi && bi.length) preload(bi[0], function () { apply(bi); }); else apply(null);
        return;
      }
      var hit = findListed(list.filter(function (o) { return imagesOf(o).length; }), sel.values, sel.complete);
      var imgs = imagesOf(hit);
      if (imgs.length) {
        preload(imgs[0], function () { apply(imgs); });
      } else if (handle && sel.complete) {
        resolveRender(handle, sel.values, titleOrder(list, sel.values), function (im) {
          if (im) return preload(im[0], function () { apply(im); });
          var loose = imagesOf(findLoose(list, sel.values));
          if (loose.length) preload(loose[0], function () { apply(loose); }); else apply(null);
        });
      } else {
        apply(null);
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || t.closest('quick-add-modal, [data-ff-ri-modal]')) return;
      if (t.name && t.name.indexOf('mw_opts[') === 0) { touched = true; pin(); update(); }
      // v15: Shopify options (Frame, Size ...) and the Top / Base dropdowns
      else if (t.closest('variant-radios, variant-selects, .ff-tb')) { touched = true; pin(); setTimeout(update, 60); setTimeout(update, 400); }
    });
    document.addEventListener('click', function () { setTimeout(function () { update(); removeAppSelectedLines(sid); }, 100); });
    // The theme re-renders the gallery after a variant change; put the render back if that happens.
    setInterval(function () {
      var c = contexts(sid)[0];
      if (current && c && c.first && !c.wrap.querySelector('img[data-apo-orig-src]')) show(sid, current);
      update();
      removeAppSelectedLines(sid);
    }, 500);
    update();
    removeAppSelectedLines(sid);
  }

  function start() {
    document.querySelectorAll('[data-apo-selection]').forEach(function (root) {
      if (root._apoSel) return;
      root._apoSel = true;
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
